import {
  Avatar,
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Text,
} from "@chakra-ui/react";
import { Courses } from "@/types/creatorcenter";

type Props = {
  courses: Courses;
};

const CreativitySchoolItem = (props:Props) => {
  const {courses} = props;

  return (
    <Box border={"1px solid rgba(238, 241, 247, 0.5)"} position="relative">
      <Image w="100%" src={courses.img_url} />
      {
        courses.tag && 
        <Box
          w={"34px"}
          h="17px"
          bg="rgba(0, 0, 0, 0.32)"
          color={"#FFFFFF"}
          fontSize="8px"
          textAlign={"center"}
          lineHeight="17px"
          position={"absolute"}
          top={"2px"}
          right={"2px"}
        >
          {courses.tag}
        </Box>
      }
      
      <Box p="10px">
        <Box fontSize={"18px"} fontWeight="700" color={"#27314D"}>
          {courses.product_name}
        </Box>
        <HStack mt="10px">
          <Avatar src={courses.avatar_url} w={"21px"} h={"21px"} />
          <Text ml="4px" color={"#333333"} fontSize="11px" fontWeight={350}>
            {courses.username}
          </Text>
        </HStack>
        <Flex mt="10px" justifyContent={"space-between"} alignItems="center">
          <Box color={"#8E94A9"} fontSize="12px">
            {courses.starttime}
          </Box>
          <Button
            borderRadius={"40px"}
            width={"72px"}
            height={"30px"}
            color="#FFFFFF"
            bgColor="#496AE1"
            fontWeight={"normal"}
            fontSize="12px"
            _hover={{
              bgColor: "#3F5BC1",
              color: "#E6E6E6",
            }}
          >
            去学习
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default CreativitySchoolItem;
